import React, { ReactElement } from 'react';
import { makeStyles } from 'tss-react/mui';

import { Copy, currentEnv, EXPLORER_LINK } from 'modules/common';
import {
  globalTranslation,
  mergeTranslations,
  useTranslation,
} from 'modules/i18n';

import { getConfig } from '../../../stake';
import { translation } from './translation';

const mergedTranslation = mergeTranslations(globalTranslation, translation);

export function TokenExplorerLink(): ReactElement {
  const { classes } = useStyles();
  const { t, keys } = useTranslation(mergedTranslation);

  const config = getConfig(currentEnv);

  const stakedTokenExplorerLink = `${EXPLORER_LINK}/object/${config.stake.certMetadata}?network=${config.network}`;

  return (
    <div className={classes.root}>
      <div>
        {t(keys.contractAddress, { stakedToken: t(keys.tokens.staked) })}
      </div>

      <div className={classes.wrap}>
        <a
          className={classes.link}
          href={stakedTokenExplorerLink}
          rel="noreferrer"
          target="_blank"
        >
          {config.stake.certMetadata}
        </a>

        <Copy text={config.stake.certMetadata} />
      </div>
    </div>
  );
}

const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  wrap: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  link: {
    wordBreak: 'break-all',
  },
}));
